import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@shared/components/ui/shadcn/accordion';
import { Label } from '@shared/components/ui/label';
import { useTranslation } from 'react-i18next';

export const Faq = () => {
  const { t } = useTranslation('suscriptionModule');
  return (
    <div className="space-y-4 mb-6 pb-8 gap-4 grid grid-cols-1 md:grid-cols-5 pt-4">
      <div className="col-span-1 md:col-span-2">
        <Label className="text-lg font-semibold">{t('main.faqTitle')}</Label>
      </div>
      <div className="col-span-1 md:col-span-3 !mt-0">
        <Accordion type="multiple" className="w-full">
          <AccordionItem value="faq-1">
            <AccordionTrigger className="text-lg font-medium">{t('main.faq1Q')}</AccordionTrigger>
            <AccordionContent className="text-sm ">{t('main.faq1A')}</AccordionContent>
          </AccordionItem>
          <AccordionItem value="faq-2">
            <AccordionTrigger className="text-lg font-medium">{t('main.faq2Q')}</AccordionTrigger>
            <AccordionContent className="text-sm ">{t('main.faq2A')}</AccordionContent>
          </AccordionItem>
          <AccordionItem value="faq-3" className="last:border-b-0">
            <AccordionTrigger className="text-lg font-medium">{t('main.faq3Q')}</AccordionTrigger>
            <AccordionContent className="text-sm ">{t('main.faq3A')}</AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};
